/* WWC dealsysteem, kern (v2): venster lui laden en openen, tegel, "Ook in een set", mand, view_promotion. Toelichting in de rapporten (r13, r14, r17, r19c) */
(function () {
  'use strict';
  if (window.WWCDealsKern) return;
  var d = document, html = d.documentElement, me = d.currentScript;
  var VENSTER = me && me.getAttribute('data-venster'), DATA = me && me.getAttribute('data-data'), DEAL = me && me.getAttribute('data-dealpagina');
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function live() { return html.classList.contains('wwc-deals-live'); }

  /* venster lui laden */
  var laden = null;
  function laad() {
    if (window.WWCDeals) return Promise.resolve();
    if (!laden) laden = fetch(DATA, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }).then(function (j) {
      window.WWCDealsData = j;
      return new Promise(function (ok, nee) { var s = d.createElement('script'); s.src = VENSTER; s.onload = ok; s.onerror = nee; d.head.appendChild(s); });
    }).catch(function (e) { laden = null; throw e; });
    return laden;
  }
  function doel(t) { return t && t.closest && t.closest('[data-wwc-set],[data-wdc-compleet],[data-wwc-set-wijzig]'); }
  ['pointerover', 'focusin', 'touchstart'].forEach(function (n) {
    d.addEventListener(n, function (e) { if (live() && doel(e.target)) laad().catch(function () {}); }, { passive: true });
  });
  var wacht = '';
  d.addEventListener('click', function (e) {
    var b = doel(e.target); if (!b || (window.WWCDeals && e.target.closest('[data-wd]') && !b.hasAttribute('data-wdc-compleet'))) return;
    e.preventDefault();
    var lade = b.closest('#CartDrawer'); if (lade) e.stopPropagation();
    var opts, id;
    if (b.hasAttribute('data-wdc-compleet')) {
      id = b.getAttribute('data-wdc-compleet');
      opts = { plek: 'mand', heb: 0, regelKey: b.getAttribute('data-key'), hebStad: b.getAttribute('data-stad'), hebPrijs: +b.getAttribute('data-prijs'), broodKey: b.getAttribute('data-brood'), broodStad: b.getAttribute('data-broodstad') };
    } else if (b.hasAttribute('data-wwc-set-wijzig')) {
      id = b.getAttribute('data-wwc-set-wijzig');
      opts = { plek: 'mand-wijzig', wijzig: b.getAttribute('data-set'), keuzes: b.getAttribute('data-keuzes'), kaartje: b.getAttribute('data-kaartje') };
    } else {
      id = b.getAttribute('data-wwc-set');
      var host = b.closest('[data-wwc-pdp-stad]');
      opts = { plek: b.getAttribute('data-wwc-plek') || 'tegel', stad: host ? host.getAttribute('data-wwc-pdp-stad') : '' };
    }
    opts.inLade = !!lade; opts.bron = b;
    var k = id + opts.plek; if (!window.WWCDeals) { if (wacht === k) return; wacht = k; }
    b.classList.add('wd-laadt'); b.setAttribute('aria-busy', 'true');
    var klaar = function () { b.classList.remove('wd-laadt'); b.removeAttribute('aria-busy'); };
    var n = 0;
    (function o() { laad().then(function () { wacht = ''; Promise.resolve(window.WWCDeals.openSet(id, opts)).then(klaar, klaar); }).catch(function () { if (!n++) setTimeout(o, 1500); else { wacht = ''; klaar(); if (DEAL && location.pathname.indexOf(DEAL) < 0 && !lade) location.href = DEAL; else location.reload(); } }); })();
  });

  /* collectie: tegel op de plek, "Ook in een set" */
  function plaats() {
    var grid = d.querySelector('.product-grid-container') || d.querySelector('[data-wwc-grid-shell] .grid'); if (!grid || !live()) return;
    var gezien = {}, tegels = $$('.wwc-deals-tegel[data-wwc-ssr]', grid).filter(function (el) { var id = el.getAttribute('data-wwc-set-tegel'); if (gezien[id]) { el.remove(); return false; } return gezien[id] = true; });
    var tpl = d.querySelector('template[data-wwc-deals-tile-tpl]');
    if (!tegels.length && tpl) tegels = Array.prototype.map.call(tpl.content.children, function (c) { var x = c.cloneNode(true); x.setAttribute('data-wwc-in-grid', ''); return x; });
    if (!tegels.length) return;
    var eerste = grid.firstElementChild;
    if (tegels.some(function (el, i) { return el.parentNode !== grid || (i ? tegels[i - 1].nextElementSibling !== el : el !== eerste); })) tegels.forEach(function (el) { grid.insertBefore(el, eerste); });
    var t = tegels.filter(function (el) { return el.offsetParent !== null; })[0], pre = t && t.getAttribute('data-wwc-ook');
    if (pre) $$('.grid-product:not(.wwc-deals-tegel)', grid).forEach(function (k) {
      if (k._wdOok || k.querySelector('.wd-ookset')) return;
      var a = k.querySelector('a[href*="/products/"]'); if (!a || a.getAttribute('href').indexOf(pre) < 0) return;
      var plek = k.querySelector('.grid-product__price') || k.querySelector('.grid-product__meta'); if (!plek) return;
      k._wdOok = true;
      var b = d.createElement('button'); b.type = 'button'; b.className = 'wd-ookset wwc-deals'; b.setAttribute('data-wwc-set', t.getAttribute('data-wwc-set-tegel')); b.setAttribute('data-wwc-plek', 'kaart'); b.textContent = t.getAttribute('data-wwc-ook-tekst') || '';
      plek.parentNode.insertBefore(b, plek.nextSibling);
    });
    meetAlles();
  }

  /* mand: alleen wat de browser weet */
  function mand() {
    var code = '';
    try { code = sessionStorage.getItem('wwc_discount_code') || ''; } catch (e) {}
    var rb = d.querySelector('[data-wwc-route-bron]'); if (rb) html.setAttribute('data-wwc-route', rb.getAttribute('data-wwc-route-bron'));
    $$('[data-wwc-mand-ssr]').forEach(function (m) {
      var setV = +m.getAttribute('data-set-v') || 0, stapelV = +m.getAttribute('data-stapel-v') || 0, codeV = +m.getAttribute('data-code-v') || 0, inMand = m.getAttribute('data-set-in-mand') === 'true';
      $$('[data-wwc-geen-code]', m).forEach(function (x) { x.hidden = !!code; });
      $$('[data-wwc-code-tekst]', m).forEach(function (x) {
        var aan = !!code && !codeV && !!(setV || stapelV || inMand) && m.getAttribute('data-kaartje') !== 'true';   /* r36 */
        x.hidden = !aan; if (aan) x.textContent = x.getAttribute('data-wwc-code-tekst').split('{code}').join(code);
      });
    });
  }
  ['cart:updated', 'cart:build', 'cart:refresh', 'ajaxCart:afterUpdate', 'cart:open'].forEach(function (n) { d.addEventListener(n, function () { setTimeout(mand, 150); }); });

  /* view_promotion, en het venster alvast laden (r19c) */
  var voor = false;
  function voorladen() { if (voor || !live()) return; voor = true; (window.requestIdleCallback || function (f) { return setTimeout(f, 200); })(function () { laad().catch(function () { voor = false; }); }); }
  var io = 'IntersectionObserver' in window && new IntersectionObserver(function (en) {
    en.forEach(function (x) {
      if (!x.isIntersecting) return; io.unobserve(x.target); voorladen();
      var el = x.target, dl = window.dataLayer = window.dataLayer || [];
      dl.push({ ecommerce: null });
      dl.push({ event: 'view_promotion', ecommerce: { promotion_id: 'set_' + el.getAttribute('data-wwc-set-tegel'), promotion_name: el.getAttribute('data-wwc-set-naam') || '', creative_slot: el.getAttribute('data-wwc-plek') || 'tegel', items: [] } });
    });
  }, { threshold: 0.5 });
  function meetAlles() { if (io) $$('[data-wwc-set-tegel][data-wwc-ssr]').forEach(function (el) { if (!el._wdM) { el._wdM = true; io.observe(el); } }); }

  /* ?set=<id>: die setkaart bovenaan de dealpagina, uitgelicht (r37, toelichting in onderzoek/ronde-38/bouw.md) */
  function uitgelicht() {
    var id = ''; try { id = (new URLSearchParams(location.search).get('set') || '').toLowerCase().replace(/[^a-z0-9_-]/g, ''); } catch (e) {}
    var grid = d.querySelector('[data-wwc-hub-sets]'); if (!id || !grid || !live()) return;
    if (d.querySelector('[data-wwc-hub-week] [data-wwc-set-tegel="' + id + '"]')) return;
    var t = grid.querySelector('[data-wwc-set-tegel="' + id + '"]'); if (!t || t.parentNode !== grid) return;
    if (grid.firstElementChild !== t) grid.insertBefore(t, grid.firstElementChild);
    t.classList.add('wdv-uitgelicht');
  }

  function start() {
    uitgelicht(); plaats(); mand(); meetAlles();
    var g = d.querySelector('.product-grid-container');
    if (g && 'MutationObserver' in window) { var mo = new MutationObserver(function () { clearTimeout(mo.t); mo.t = setTimeout(plaats, 150); }); mo.observe(g, { childList: true }); }
    var p = d.querySelector('#CartDrawer [data-products]');
    if (p && 'MutationObserver' in window) { var mp = new MutationObserver(function () { clearTimeout(mp.t); mp.t = setTimeout(mand, 60); }); mp.observe(p, { childList: true }); }
  }
  d.addEventListener('wwc:collection:updated', function () { setTimeout(plaats, 100); });
  window.WWCDealsKern = { versie: 1, laad: laad, mand: mand, plaats: plaats };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})();
